import { tokenService } from "../auth/TokenService";

/**
 * @deprecated Use tokenService.getAuthHeaders() instead
 * This function is kept for backward compatibility
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
  return tokenService.getAuthHeaders();
}
